import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { funnyPlaceholder } from '../../constants/placeholder';
import {
  useGetCustomSelectButtonElement,
  useSetMultipleRangeDefaultValue,
} from '../../hooks/init';
import CustomSelect from '../../components/CustomSelect';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
const options = [
  { text: '0 ~ 5 people', value: '0-5' },
  { text: '5 ~ 10 people', value: '5-10' },
  { text: '10 ~ 20 people', value: '10-20' },
  { text: '> 20 people', value: '20-' },
];
export default function FunnysSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const { formatOptionsMessage, formatMessage } = useLanguage();
  const { rangeValue, setRangeValue, diffClassName } =
    useSetMultipleRangeDefaultValue({
      defaultValue,
      filterValue,
      oriDefaultFilter,
      backOriDefaultValue,
      defaultKey: 'funnys',
      startKey: 'start_funny',
      endKey: 'end_funny',
      options,
    });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    const data: { start_funny: number; end_funny?: number | undefined }[] = [];
    if (!isAll) {
      rangeValue.map((item: string) => {
        const [start, end] = item.split('-');
        let dataItem: { start_funny: number; end_funny?: number } = {
          start_funny: Number(start),
        };
        if (end !== '') {
          dataItem['end_funny'] = Number(end);
        }
        data.push(dataItem);
      });
    }

    onChange?.(
      'funnys',
      commonBackInfo(
        { funnys: data },
        { funnys: text },
        {
          needChangeEntity: true,
          defaultValue: { start_funny: -99999, end_funny: -99999 },
          isAll,
        },
      ),
    );
  }, [rangeValue, formatMessage]);

  return (
    <div className={diffClassName}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={funnyPlaceholder[lang]}
        onClear={() => setRangeValue([] as any)}
        showNumber={3}
        selectOptionsInfo={[rangeValue, setRangeValue]}
        options={formatOptionsMessage(options)}
        pointKey={FilterButtonPoint.funnys}
      ></CustomSelect>
    </div>
  );
}
